<template>
  <el-card>
    <ht-action-panel :on-search="mySearch" :on-clear="myClear">
      <template slot="left">
        <el-select v-model="listQuery.accidentType" placeholder="事故类型">
          <el-option
            v-for="item in accidentTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <common-search ref="commonSearch" :staff-placeholder="'登记人'" @handleSelect="handleSelect" @selectDate="selectDate" />
      </template>
      <!--      <template slot="right">-->
      <!--        <el-button v-if="!showSelector" type="danger" icon="el-icon-delete" @click="showSelectedCheckRecord">-->
      <!--          批量删除-->
      <!--        </el-button>-->
      <!--        <template v-else>-->
      <!--          <el-button type="danger" icon="el-icon-delete">-->
      <!--            确定删除-->
      <!--          </el-button>-->
      <!--          <el-button type="text" @click="showSelector = false">取消删除</el-button>-->
      <!--        </template>-->
      <!--      </template>-->
    </ht-action-panel>
    <ht-table
      ref="list"
      v-loading="isLoading"
      :data="list"
      :row-key="getRowKey"
      :default-sort="{prop: 'createdAt', order: 'descending'}"
      style="cursor: pointer"
      @row-click="handleRowClick"
      @selection-change="selectionChange"
      @sort-change="sortChange"
    >
      <!--      <el-table-column-selection v-if="showSelector" />-->
      <el-table-column label="序号" type="index" fixed="left" />
      <ht-table-column v-for="i in labelToProps" :key="i.prop" :label="i.label" :prop="i.prop" :sortable="i.sortable">
        <template v-slot="{row}">
          <span v-if="i.format === 'status'">
            <status :status="row.status.value" :status-types="{ 草稿: 'danger', 已提交: 'success' }" />
          </span>
          <span v-else>
            <span v-if="i.secondProp">{{ (row[i.firstProp] && row[i.firstProp][i.secondProp]) ? row[i.firstProp][i.secondProp] : '-' }}</span>
            <span v-else>{{ row[i.prop] }}</span>
          </span>
        </template>
      </ht-table-column>
      <ht-table-column-operation>
        <template v-slot="{row}">
          <ht-button type="text" icon="el-icon-view" @click="gotoView(row.id)">详情</ht-button>
          &nbsp;|&nbsp;&nbsp;
          <ht-popover-button
            icon="el-icon-delete"
            type="text"
            :danger-text="true"
            confirm-title="请确认是否要删除该条数据？"
            @confirmed="deleteItem(row)"
          >删除
          </ht-popover-button>
        </template>
      </ht-table-column-operation>
    </ht-table>
    <ht-pagination
      style="float: right;margin-bottom: 10px"
      :total="page.total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.perPage"
      @pagination="getList"
    />
  </el-card>
</template>

<script>
import HtListContainer from '@/components/HtListContainer/index'
import { getAccidentRecordsApi, deleteAccidentRecordDetail } from '@/api/secureEnvironmentMgr/accidentRecord'
import { sortQuery } from '@/utils'

export default {
  extends: HtListContainer,
  props: {
    bizType: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      labelToProps: [
        {
          label: '编号',
          prop: 'recordNo'
        },
        {
          label: '事故类型',
          prop: 'accidentType',
          firstProp: 'accidentType',
          secondProp: 'value',
          sortable: 'custom'
        },
        {
          label: '登记人',
          prop: 'staff.fullName',
          firstProp: 'staff',
          secondProp: 'fullName',
          sortable: 'custom'
        },
        {
          label: '时间',
          prop: 'createdAt',
          sortable: 'custom'
        },
        {
          label: '位置区域',
          prop: 'locationAndInfo',
          sortable: 'custom'
        },
        {
          label: '备注',
          prop: 'comment'
        },
        {
          label: '状态',
          format: 'status',
          prop: 'status',
          sortable: 'custom'
        }
      ],
      showSelector: false,
      selectedCheckRecord: [],
      searchForm: {
        searchStaffName: undefined,
        searchDate: undefined
      },
      accidentTypeList: [
        { label: '全部' },
        { label: '已遂', value: 'HAPPENED' },
        { label: '未遂', value: 'ATTEMPT' }
      ]
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.beforeGetList()
      getAccidentRecordsApi(this.listQuery).then((resp) => {
        this.afterGetList(resp)
      })
    },
    selectionChange(val) {
      this.selectedCheckRecord = val
    },
    sortChange(ev) {
      this.listQuery.sort = sortQuery(ev)
      this.getList()
    },
    showSelectedCheckRecord() {
      this.showSelector = true
      this.$message({
        message: '请勾选需要批量删除的记录',
        center: true,
        type: 'warning'
      })
    },
    deleteItem(row) {
      deleteAccidentRecordDetail(row.id).then(() => {
        this.$message({ message: '删除成功！', center: true, type: 'success' })
        this.getList()
      })
    },
    handleRowClick(row, column) {
      if (column.label !== '操作' && !this.showSelector) {
        this.gotoView(row.id)
      }
    },
    gotoView(accidentId) {
      this.$router.push({ name: 'accidentRegisterView', params: { accidentId: accidentId }})
    },
    handleSelect(id) {
      this.listQuery.staffId = id
    },
    selectDate(date) {
      if (date) {
        this.listQuery.startAt = date[0]
        this.listQuery.endAt = date[1]
      }
    },
    mySearch() {
      const searchForm = this.$refs.commonSearch.searchForm
      if (searchForm.searchStaffName) {
        if (this.listQuery.staffId) {
          this.onSearch()
        } else {
          this.$message({ message: '请在下拉框内选择员工后进行搜索', center: true, type: 'warning' })
        }
      } else if (this.listQuery.startAt && this.listQuery.endAt) {
        this.onSearch()
      } else {
        this.onSearch()
      }
    },
    myClear() {
      this.$refs.commonSearch.searchForm = { searchStaffName: undefined, searchDate: undefined }
      this.onClear()
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-table__body tr.hover-row>td{
  background-color: #eaecfc !important;
}
</style>
